var exports = {
  "kL": "DMSidebarSkeleton.module__container___a2p2Rk",
  "Kd": "DMSidebarSkeleton.module__containerMobile___a2p2Rk",
  "wx": "DMSidebarSkeleton.module__header___a2p2Rk",
  "Od": "DMSidebarSkeleton.module__mobileHeader___a2p2Rk",
  "Fy": "DMSidebarSkeleton.module__mobileHeaderActions___a2p2Rk",
  "P1": "DMSidebarSkeleton.module__scrollArea___a2p2Rk",
  "Qs": "DMSidebarSkeleton.module__content___a2p2Rk",
  "wh": "DMSidebarSkeleton.module__mobileContent___a2p2Rk",
  "jH": "DMSidebarSkeleton.module__spacer___a2p2Rk",
  "nM": "DMSidebarSkeleton.module__row___a2p2Rk",
  "TZ": "DMSidebarSkeleton.module__mobileRow___a2p2Rk",
  "u4": "DMSidebarSkeleton.module__rowContent___a2p2Rk",
  "yW": "DMSidebarSkeleton.module__channelInfo___a2p2Rk",
  "jn": "DMSidebarSkeleton.module__channelNameRow___a2p2Rk",
  "$s": "DMSidebarSkeleton.module__channelSubtextRow___a2p2Rk",
  "me": "DMSidebarSkeleton.module__separator___a2p2Rk",
  "bV": "DMSidebarSkeleton.module__sectionHeader___a2p2Rk",
  "o5": "DMSidebarSkeleton.module__channelList___a2p2Rk",
  "US": "DMSidebarSkeleton.module__bottomSpacer___a2p2Rk",
  "cB": "DMSidebarSkeleton.module__mobileFab___a2p2Rk",
};

module.exports = exports;
